import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import animated from "animate.css";
import "./assets/css/index.css";
import "./assets/css/iconfont.css";
import "./assets/css/markdown.css";
import "./assets/css/vue-social-share/client.css";
import config from "./assets/js/config";
import Share from "vue-social-share";
import dayjs from "dayjs";
import { vueBaberrage } from "vue-baberrage";
import axios from "axios";
import VueAxios from "vue-axios";
import InfiniteLoading from "vue-infinite-loading";
import VueImageSwipe from "vue-image-swipe";
import "vue-image-swipe/dist/vue-image-swipe.css";
import Toast from "./components/toast/index";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import MetaInfo from "vue-meta-info";
import MathJax from "./common/MathJax.js"; // MathJax.js内容在1.3，位置随意
import VueUploadImgs from "vue-upload-imgs";
import VueClipboard from "vue-clipboard2";
import "@mdi/font/css/materialdesignicons.css";
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";
// 引入样式
import "vue-easytable/libs/theme-default/index.css";
// 引入组件库
import VueEasytable from "vue-easytable";
import VueCountdown from "@chenfengyuan/vue-countdown";
// import loader from './data/loader.js' // MathJax.js内容在1.3，位置随意

Vue.component(VueCountdown.name, VueCountdown);
Vue.prototype.MathJax = MathJax;
// Vue.prototype.loader = loader
Vue.use(MetaInfo);
Vue.prototype.config = config;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(animated);
Vue.use(Share);
Vue.use(vueBaberrage);
Vue.use(InfiniteLoading);
Vue.use(VueAxios, axios);
Vue.use(VueImageSwipe);
Vue.use(Toast);
Vue.use(VueUploadImgs);
Vue.use(VuePlyr, {
  plyr: {},
});
Vue.use(VueClipboard);
Vue.use(VueEasytable);

Vue.filter("date", function(value) {
  return dayjs(value).format("YYYY-MM-DD");
});

Vue.filter("year", function(value) {
  return dayjs(value).format("YYYY");
});

Vue.filter("hour", function(value) {
  return dayjs(value).format("HH:mm:ss");
});

Vue.filter("num", function(value) {
  if (value >= 1000) {
    return (value / 1000).toFixed(1) + "k";
  }
  return value;
});

router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(["_trackPageview", to.fullPath]);
    }
  }
  NProgress.start();
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

router.afterEach(() => {
  window.scrollTo({
    top: 0,
    behavior: "instant",
  });
  NProgress.done();
});

axios.interceptors.response.use(
  function(response) {
    switch (response.data.code) {
      case 50000:
        Vue.prototype.$toast({ type: "error", message: "系统异常" });
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

// 全局设置tooltip延时
ElementUI.Tooltip.props.openDelay.default = 300;

document.addEventListener("plusready", function(a) {
  //等待plus ready后再调用5+ API：  在这里调用5 + API
  var first = null;
  plus.key.addEventListener(
    "backbutton",
    function() {
      //监听返回键
      //首次按键，提示‘再按一次退出应用’
      if (!first) {
        first = new Date().getTime(); //获取第一次点击的时间戳
        // console.log('再按一次退出应用');//用自定义toast提示最好
        // toast('双击返回键退出应用'); //调用自己写的吐丝提示 函数
        plus.nativeUI.toast("再按一次退出Seayouth.AI", { duration: "short" }); //通过H5+ API 调用Android 上的toast 提示框
        setTimeout(function() {
          first = null;
        }, 1000);
      } else {
        if (new Date().getTime() - first < 1000) {
          //获取第二次点击的时间戳, 两次之差 小于 1000ms 说明1s点击了两次,
          plus.runtime.quit(); //退出应用
        }
      }
    },
    false
  );
});
